import { withTheme } from '@digital-retail/falabella-ui-cross-components';
import PropTypes from 'prop-types';
import { noop } from '../../../../utils/noop';
import Image from '../../../ui/Image/Image';
import { useImageGalleryCarousel } from '../hooks/useImageGalleryCarousel';
import { ImageGalleryCarouselStyles } from './ImageGalleryCarouselDesktop.style';
import { getCarouselWrapperClasses, getIndicatorDotClasses } from './utils';

const ImageGalleryCarouselDesktop = ({
  carouselImageHeight,
  carouselImageWidth,
  activeImageIndex,
  activeIndicatorIndex,
  imagesPerSlide,
  setActiveImageIndex,
  setActiveIndicatorIndex,
  carouselImages,
  images,
  productName,
  brandName,
  theme,
}) => {
  const themedStyles = ImageGalleryCarouselStyles(theme);

  // Use the custom hook to get processed data and handlers
  const {
    processedCarouselItems,
    processedIndicators,
    shouldShowIndicators: showIndicators,
    handleCarouselItemClick,
    handleIndicatorClick,
  } = useImageGalleryCarousel({
    carouselImages,
    images,
    activeImageIndex,
    activeIndicatorIndex,
    imagesPerSlide,
    setActiveImageIndex,
    setActiveIndicatorIndex,
    productName,
    brandName,
    carouselImageWidth,
    carouselImageHeight,
  });

  const getCarouselItem = (itemData) => {
    if (itemData.isVideo) {
      return <div className="image-carousel video"> </div>;
    }
    return (
      <Image
        id={itemData.mediaId}
        imageUrl={itemData.mediaUrl}
        width={itemData.width}
        height={itemData.height}
        alt={itemData.altText}
        lazyLoad
        inlineDimensions={false}
        carrouselImagePosition={itemData.index + 1}
      />
    );
  };

  return (
    <div className="image-carousel desktop fa--image-gallery-carousel__desktop rebranded">
      <div className="carousel">
        {processedCarouselItems.map((itemData) => (
          <div
            className={getCarouselWrapperClasses(itemData.isActive, itemData.isVideo)}
            onClick={() => handleCarouselItemClick(itemData.index)}
            role="button"
            key={itemData.key}
            tabIndex="0"
            onKeyDown={noop}
            id={itemData.id}
          >
            {getCarouselItem(itemData)}
          </div>
        ))}
      </div>

      {showIndicators && (
        <div className="indicator">
          {processedIndicators.map((indicatorData) => (
            <div
              onClick={() => handleIndicatorClick(indicatorData.index)}
              role="button"
              tabIndex="0"
              key={indicatorData.key}
              onKeyDown={noop}
              className={getIndicatorDotClasses(indicatorData.isActive)}
              id={indicatorData.id}
            />
          ))}
        </div>
      )}
      <style jsx>{themedStyles}</style>
    </div>
  );
};

ImageGalleryCarouselDesktop.defaultProps = {
  images: [],
  carouselImages: [],
  theme: null,
};

ImageGalleryCarouselDesktop.propTypes = {
  carouselImageHeight: PropTypes.number.isRequired,
  carouselImageWidth: PropTypes.number.isRequired,
  carouselImages: PropTypes.array,
  activeImageIndex: PropTypes.number.isRequired,
  activeIndicatorIndex: PropTypes.number.isRequired,
  imagesPerSlide: PropTypes.number.isRequired,
  setActiveImageIndex: PropTypes.func.isRequired,
  setActiveIndicatorIndex: PropTypes.func.isRequired,
  images: PropTypes.array,
  productName: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
  theme: PropTypes.object,
};

export default withTheme(ImageGalleryCarouselDesktop);
